module.exports = __webpack_public_path__ + "img/20190718163546922.aaba2c3c.png";